// RecentActivityV3 — MOCKED feed. Reads /api/dashboard-v3/activity-recent
// (returns 5 mock items with `mock:true` flag). Time is relative and
// localized IT-first.
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { apiFetch } from "@/lib/api";
import ActivityItemV3 from "../components/ActivityItemV3";

function relativeTime(iso, t) {
    if (!iso) return "";
    const now = Date.now();
    const then = new Date(iso).getTime();
    if (Number.isNaN(then)) return "";
    const diffMin = Math.max(0, Math.round((now - then) / 60000));
    if (diffMin < 1) return t("activity.just_now");
    if (diffMin < 60) return t("activity.minutes_ago", { count: diffMin });
    const diffH = Math.round(diffMin / 60);
    if (diffH < 24) return t("activity.hours_ago", { count: diffH });
    const diffD = Math.round(diffH / 24);
    return t("activity.days_ago", { count: diffD });
}

export default function RecentActivityV3() {
    const { t } = useTranslation("dashboard_v3");
    const [items, setItems] = useState([]);
    const [isMock, setIsMock] = useState(false);

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const data = await apiFetch("/dashboard-v3/activity-recent");
                if (!mounted) return;
                setItems(Array.isArray(data?.items) ? data.items : []);
                setIsMock(!!data?.mock);
            } catch {
                if (mounted) setItems([]);
            }
        })();
        return () => { mounted = false; };
    }, []);

    return (
        <section aria-labelledby="activity-heading" className="mt-10">
            <div className="flex items-center justify-between mb-3">
                <h2
                    id="activity-heading"
                    className="text-[11px] uppercase tracking-widest text-[#CCCCCC] font-semibold"
                >
                    {t("activity.headline")}
                </h2>
                {isMock && (
                    <span
                        className="text-[10px] uppercase tracking-widest px-2 py-1 rounded-full font-semibold"
                        style={{
                            backgroundColor: "rgba(204, 204, 204,0.12)",
                            color: "#CCCCCC",
                        }}
                        data-testid="dashboard-v3-activity-mock"
                    >
                        {t("activity.demo_banner")}
                    </span>
                )}
            </div>
            <div
                className="rounded-2xl border p-2"
                style={{ backgroundColor: "#111111", borderColor: "#1A1A1A" }}
            >
                {items.length === 0 ? (
                    <p className="px-3 py-4 text-sm text-[#CCCCCC]">
                        {t("activity.empty")}
                    </p>
                ) : (
                    <ul className="divide-y divide-white/[0.04]">
                        {items.map((it, i) => {
                            const text = t(it.text_key, { ...(it.text_vars || {}) });
                            return (
                                <ActivityItemV3
                                    key={it.id || i}
                                    testId={`dashboard-v3-activity-item-${i}`}
                                    type={it.type}
                                    text={text}
                                    timeLabel={relativeTime(it.created_at, t)}
                                />
                            );
                        })}
                    </ul>
                )}
            </div>
        </section>
    );
}
